/**
 * Jay@airwhizz.com
 * Description :
 *
 * @input :
 * @output :
 *
 *
 */
import React, {Component} from 'react';
import {Button, Card, Form, Icon, Input, Popover, Upload} from 'antd';

import {connect} from "react-redux";
import {uploadJobCards} from "../../appRedux/actions/JobCard";

const {Search} = Input;

class JobUpload extends Component {
  state = {
    fileList: [],
    uploading: false,
  };
  handleUpload = () => {
    const {fileList} = this.state;
    const formData = new FormData();
    // fileList.forEach(file => {
    formData.append('file', fileList[0]);
    // });
    this.setState({
      uploading: true,
    });
    this.props.uploadJobCards(formData);
  };

  UNSAFE_componentWillReceiveProps(nextProps, _) {
    if(nextProps && JSON.stringify(nextProps.loading) && JSON.stringify(this.props.loading) !== JSON.stringify(nextProps.loading)) {
      this.setState({
        uploading: nextProps.loading,
      });
    }
  }

  templateContent = (
    <div>
      <p>CSV file template</p>
      <Button size={'small'} onClick={() => {
        window.open('../csv_template/BulkJobCardTemplate.csv', '_blank');
      }}>Download</Button>
    </div>
  );

  render() {
    const {uploading, fileList} = this.state;
    const props = {
      accept: "text/csv",
      onRemove: file => {
        this.setState(state => {
          const index = state.fileList.indexOf(file);
          const newFileList = state.fileList.slice();
          newFileList.splice(index, 1);
          return {
            fileList: newFileList,
          };
        });
      },
      beforeUpload: file => {
        this.setState(state => ({
          fileList: [...state.fileList, file],
        }));
        return false;
      },
      fileList,
    };
    return (
      <div>
        <Card title={`Complain and Job Card bulk creation`}>
          <Upload {...props}>
            <Button>
              <Icon type="upload"/> Select File to upload
            </Button>
          </Upload>
          <Button
            type="primary"
            onClick={this.handleUpload}
            disabled={fileList.length === 0}
            loading={uploading}
            style={{marginTop: 16}}
          >
            {uploading ? 'Uploading' : 'Start Upload'}
          </Button>
          <Popover content={this.templateContent} title="" trigger="click">
            <Button type="default" shape="circle" icon="download" size={'small'}/>
          </Popover>
        </Card>
      </div>
    );
  }
}

const mapStateToProps = ({auth, jobCard, commonData}) => {
  return {
    authUser: auth.authUser,
    // searchData: jobCard.searchData,
    // resource: jobCard.resource,
    loading: commonData.loading,
    // filters: commonData.filters,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    // fetchFilter,
    // searchResource,
    uploadJobCards
  };
}

const JobCardUpload = Form.create({name: 'job-card-search'})(JobUpload);
export default connect(mapStateToProps, mapDispatchToProps())(JobCardUpload);
